import React from 'react';
import FlashbetTicketBody from '../flashbet-ticket/FlashbetTicketBody';
import FlashbetTicketFooter from '../flashbet-ticket/FlashbetTicketFooter';
import FlashbetTicketHeader from '../flashbet-ticket/FlashbetTicketHeader';

function FlashbetTicket(props) {
	
	const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration
	const user = props.user;
	const isCashout = props.isCashout;
	return <>
	<div id={"ticket-" + ticketData.idTicket} className="flashbet-ticket-container">
		<FlashbetTicketHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} isCashout={isCashout} user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<FlashbetTicketBody isCashout={isCashout} user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<FlashbetTicketFooter isCashout={isCashout} user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		
	</div>
	</>
}

export default FlashbetTicket;